import { render, staticRenderFns } from "./ComprobanteGastoPage.vue?vue&type=template&id=66b1cb48"
import script from "./ComprobanteGastoPage.js?vue&type=script&lang=js&external"
export * from "./ComprobanteGastoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports